// src/components/Services/Services.tsx
import Container from "../ui/Container";
import SectionHeader from "../ui/SectionHeader";
import ServiceCard from "./ServiceCard";
import { Home, Shield, Landmark, Building2 } from "lucide-react";

export default function Services() {
    const services = [
        {
            title: "Loans",
            description: "Quick approvals with low interest rates.",
            icon: <Landmark className="h-12 w-12" />,
        },
        {
            title: "Insurance",
            description: "Secure LIC & other insurance services.",
            icon: <Shield className="h-12 w-12" />,
        },
        {
            title: "Thawa FSPL",
            description: "Reliable thawa financial services.",
            icon: <Building2 className="h-12 w-12" />,
        },
        {
            title: "Real Estate",
            description: "Trusted real estate buying & selling solutions.",
            icon: <Home className="h-12 w-12" />,
        },
    ];

    return (
        <section id="services" className="py-16 bg-gray-50">
            <Container>
                <SectionHeader title="Our Services" subtitle="We provide finance, insurance, thawa & real estate solutions" />
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                    {services.map((s) => (
                        <ServiceCard
                            key={s.title}
                            title={s.title}
                            description={s.description}
                            icon={s.icon}
                        />
                    ))}
                </div>
            </Container>
        </section>
    );
}
